import React from "react";
const AppContext = React.createContext({
    state: {}
});

export default AppContext;